// extracted by mini-css-extract-plugin
export default {"code":"styles_code__+2sV3","inlineCode":"styles_inlineCode__C4Lh+"};